import { render, staticRenderFns } from "./TheSimpsonsHome.vue?vue&type=template&id=4563ef9a&scoped=true&"
import script from "./TheSimpsonsHome.vue?vue&type=script&lang=js&"
export * from "./TheSimpsonsHome.vue?vue&type=script&lang=js&"
import style0 from "./TheSimpsonsHome.vue?vue&type=style&index=0&id=4563ef9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563ef9a",
  null
  
)

export default component.exports